/**
 * COPIA de goautos-admin src/components/builder2/i18n/defaultsPt.b.ts (mismo
 * contenido; si se cambia allá, copiarlo acá). En el sitio lo usa
 * builder2/utils/defaultsPt.ts para traducir al vuelo, solo en Brasil.
 *
 * Textos de fábrica del editor del sitio: español EXACTO (clave) → portugués de
 * Brasil (valor). Parte B: el resto de las secciones (vehicles/, marketing/,
 * contact/, features/, layout/ y demás) y los defaults de contenido de
 * settings/componentSettings.ts. Ver localizarDefaults.ts.
 *
 * Quedan AFUERA a propósito (no se pueden traducir por coincidencia exacta sin
 * romper algo):
 * - nombres de categoría / estado / tipo de vehículo ('Sedán', 'Camioneta',
 *   'Vehículos de trabajo', 'Publicado', 'Vendido', 'Todos'…): son valores que
 *   se comparan contra la base o contra un centinela;
 * - 'Nuevo' (newBadgeText de TraditionalVehicleGrid): es un centinela
 *   (`newBadgeText === 'Nuevo'` rota las etiquetas automáticas);
 * - textos que en portugués quedan iguales ('Marca 1', 'Ver todos', 'Empresa',
 *   'Cargo', 'Valor', 'Ver catálogo', 'Cliente desde 2023'…).
 */
export const DEFAULTS_PT_B: Record<string, string> = {
  // ── vehicles/ ──────────────────────────────────────────────────────────────
  'Sin resultados': 'Nenhum resultado',
  'No encontramos vehículos con esos filtros': 'Não encontramos veículos com esses filtros',
  'Ver todos los vehículos': 'Ver todos os veículos',
  'Nuestros vehículos': 'Nossos veículos',
  'Explora nuestro inventario de vehículos disponibles': 'Explore nosso estoque de veículos disponíveis',

  // ── marketing/ (logos, premios, confianza, cifras, promo) ─────────────────
  'Bancos partners': 'Bancos parceiros',
  'Certificaciones': 'Certificações',
  'Con el respaldo de los mejores': 'Com o respaldo dos melhores',
  'Trabajamos con empresas e instituciones de primer nivel': 'Trabalhamos com empresas e instituições de primeira linha',
  'Nueva categoría': 'Nova categoria',
  'Marcas que trabajamos': 'Marcas com que trabalhamos',
  'Confían en nosotros las marcas más reconocidas del mercado': 'As marcas mais reconhecidas do mercado confiam em nós',
  'Mejor Automotora': 'Melhor Concessionária',
  'Reconocimiento al servicio al cliente': 'Reconhecimento pelo atendimento ao cliente',
  'Concesionario Certificado': 'Concessionária Certificada',
  'Estándares de calidad internacionales': 'Padrões de qualidade internacionais',
  'Premio Excelencia': 'Prêmio Excelência',
  'Otorgado por AutoChile': 'Concedido pela AutoBrasil',
  'Reconocimientos': 'Reconhecimentos',
  'Reconocimientos y certificaciones': 'Reconhecimentos e certificações',
  'Nuestro trabajo respaldado por las principales instituciones del rubro': 'Nosso trabalho reconhecido pelas principais instituições do setor',
  'En cifras': 'Em números',
  'Nuestros números': 'Nossos números',
  'Satisfacción del cliente': 'Satisfação do cliente',
  'Tiempo de respuesta': 'Tempo de resposta',
  'Garantía 12 meses': 'Garantia de 12 meses',
  'Cobertura completa de motor y transmisión': 'Cobertura completa de motor e câmbio',
  'Inspección 150 puntos': 'Inspeção de 150 itens',
  'Cada vehículo revisado por mecánicos certificados': 'Cada veículo revisado por mecânicos certificados',
  'Devolución 7 días': 'Devolução em 7 dias',
  'Si no quedas conforme, te devolvemos tu plata': 'Se não ficar satisfeito, devolvemos o seu dinheiro',
  'Financiamiento aprobado': 'Financiamento aprovado',
  'En 24 horas, con o sin pie': 'Em 24 horas, com ou sem entrada',
  '¿Por qué confiar en nosotros?': 'Por que confiar em nós?',
  'Compromisos concretos con cada cliente': 'Compromissos concretos com cada cliente',
  '¡Oferta especial! Aprovecha nuestras promociones exclusivas este mes.': 'Oferta especial! Aproveite nossas promoções exclusivas deste mês.',

  // ── testimonials/ ──
  'Juan Pérez': 'João Pereira',
  'Excelente servicio de principio a fin. El proceso de compra fue rápido y transparente.':
    'Excelente atendimento do início ao fim. O processo de compra foi rápido e transparente.',
  'Excelente servicio de principio a fin. El proceso de compra fue rápido y transparente. Estoy muy contento con mi nuevo auto.':
    'Excelente atendimento do início ao fim. O processo de compra foi rápido e transparente. Estou muito feliz com meu carro novo.',
  'El asesor fue muy paciente y resolvió todas mis dudas. Me ayudaron con el financiamiento perfecto.':
    'O consultor foi muito paciente e tirou todas as minhas dúvidas. Me ajudaram com o financiamento perfeito.',
  'El asesor fue muy paciente y resolvió todas mis dudas. Me ayudaron a conseguir el financiamiento perfecto para mis necesidades.':
    'O consultor foi muito paciente e tirou todas as minhas dúvidas. Me ajudaram a conseguir o financiamento perfeito para as minhas necessidades.',
  'La garantía y el servicio post-venta son excelentes. Me han atendido siempre sin problemas.':
    'A garantia e o pós-venda são excelentes. Sempre fui atendido sem problemas.',
  'La garantía y el servicio post-venta son excelentes. Me han atendido siempre que lo he necesitado sin problemas.':
    'A garantia e o pós-venda são excelentes. Sempre fui atendido sem problemas quando precisei.',
  'Excelente experiencia de compra.': 'Excelente experiência de compra.',
  'El mejor servicio postventa.': 'O melhor pós-venda.',
  'Financiamiento rápido y transparente.': 'Financiamento rápido e transparente.',
  'Experiencia excepcional.': 'Experiência excepcional.',

  // ── layout/ (navbar y footer) ──
  'Redes sociales': 'Redes sociais',
  'Tu aliado de confianza en la compra de vehículos.': 'Seu parceiro de confiança na compra de veículos.',

  // ── contact/ ──
  'Encuentranos en la siguiente dirección:': 'Encontre-nos no seguinte endereço:',
  'Cómo llegar en Google Maps': 'Como chegar pelo Google Maps',
  'Cómo llegar': 'Como chegar',
  'Hola, me interesa saber más sobre sus vehículos disponibles.': 'Olá, tenho interesse em saber mais sobre os veículos disponíveis.',
  'Hola, me interesa saber más sobre sus vehículos.': 'Olá, tenho interesse em saber mais sobre os veículos.',
  '¿Tienes dudas? Escríbenos': 'Tem dúvidas? Fale com a gente',
  'Escribinos por WhatsApp': 'Fale conosco pelo WhatsApp',
  '¿Listo para encontrar tu próximo vehículo?': 'Pronto para encontrar o seu próximo veículo?',
  'Contáctanos hoy mismo.': 'Fale conosco hoje mesmo.',
  'Contáctanos hoy y descubre las mejores opciones de financiamiento.': 'Fale conosco hoje e descubra as melhores opções de financiamento.',
  'Reserva una cita personalizada.': 'Reserve um horário personalizado.',

  // ── features/ (FAQ, por qué elegirnos) ──
  '¿Qué tipos de vehículos ofrecen?': 'Que tipos de veículos vocês oferecem?',
  'Ofrecemos una amplia gama de vehículos, desde compactos hasta SUVs y vehículos de lujo. Todos nuestros vehículos son seminuevos y han pasado por un riguroso proceso de inspección.':
    'Oferecemos uma ampla variedade de veículos, de compactos a SUVs e veículos de luxo. Todos os nossos veículos são seminovos e passaram por um rigoroso processo de inspeção.',
  '¿Cómo funciona el financiamiento?': 'Como funciona o financiamento?',
  'Trabajamos con diversas entidades financieras para ofrecer opciones que se adapten a tus necesidades. Nuestros asesores pueden ayudarte a encontrar el plan más adecuado según tu situación financiera.':
    'Trabalhamos com diversas instituições financeiras para oferecer opções que se adaptem às suas necessidades. Nossos consultores podem ajudar você a encontrar o plano mais adequado à sua situação financeira.',
  '¿Ofrecen garantía en sus vehículos?': 'Vocês oferecem garantia nos veículos?',
  'Sí, todos nuestros vehículos incluyen garantía. La duración y cobertura pueden variar según el modelo, año y estado del vehículo. Consulta con nuestros asesores para más detalles.':
    'Sim, todos os nossos veículos incluem garantia. A duração e a cobertura podem variar conforme o modelo, o ano e o estado do veículo. Fale com nossos consultores para mais detalhes.',
  'Trabajamos con las principales instituciones y la aprobación suele salir en 24 horas.':
    'Trabalhamos com as principais instituições e a aprovação costuma sair em 24 horas.',
  '¿Los vehículos tienen garantía?': 'Os veículos têm garantia?',
  'Todos incluyen 6 meses de garantía mecánica.': 'Todos incluem 6 meses de garantia mecânica.',
  '¿Reciben mi auto en parte de pago?': 'Vocês aceitam meu carro como parte do pagamento?',
  'Sí, lo tasamos sin costo y lo tomamos como pie.': 'Sim, avaliamos sem custo e aceitamos como entrada.',
  'Garantía': 'Garantia',
  'Todos nuestros vehículos cuentan con garantía': 'Todos os nossos veículos têm garantia',
  'Opciones de financiamiento flexibles': 'Opções de financiamento flexíveis',
  'Calidad': 'Qualidade',
  'Vehículos seleccionados y certificados': 'Veículos selecionados e certificados',
  'Descubre por qué nuestros clientes confían en nosotros': 'Descubra por que nossos clientes confiam em nós',
  'Descubre las ventajas que nos hacen únicos en el mercado automotriz': 'Descubra as vantagens que nos tornam únicos no mercado automotivo',
  'Autos inspeccionados y garantizados': 'Carros inspecionados e com garantia',
  'Cada vehículo pasa por un riguroso proceso de inspección para garantizar tu seguridad y tranquilidad.':
    'Cada veículo passa por um rigoroso processo de inspeção para garantir a sua segurança e tranquilidade.',
  'Planes de financiamiento flexibles diseñados para adaptarse a tus necesidades y presupuesto.':
    'Planos de financiamento flexíveis, pensados para se adaptar às suas necessidades e ao seu orçamento.',
  'Atención personalizada': 'Atendimento personalizado',
  'Un asesor dedicado te acompaña en cada paso del proceso de compra.': 'Um consultor dedicado acompanha você em cada etapa da compra.',
  'Seguridad y calidad aseguradas': 'Segurança e qualidade garantidas',
  'Diseñado según tus necesidades': 'Pensado para as suas necessidades',
  'Un asesor te acompaña en todo el proceso': 'Um consultor acompanha você em todo o processo',
  'Planes a tu medida': 'Planos sob medida',

  // ── media/ (galería y carrusel) ────────────────────────────────────────────
  'Galería': 'Galeria',
  'Nuestra Galeria': 'Nossa Galeria',
  'Deportivo de lujo en exhibicion': 'Esportivo de luxo em exposição',
  'Clasico americano restaurado': 'Clássico americano restaurado',
  'Sedan moderno con tecnologia avanzada': 'Sedã moderno com tecnologia avançada',
  'Vehiculo deportivo rojo': 'Veículo esportivo vermelho',
  'SUV familiar en carretera': 'SUV familiar na estrada',
  'Vista lateral de un Corvette': 'Vista lateral de um Corvette',
  'Descubre nuestras instalaciones': 'Conheça nossas instalações',

  // ── team/ ──────────────────────────────────────────────────────────────────
  'Conócenos': 'Conheça-nos',
  // Mismo 'Carlos' que 'Carlos Rodríguez' (con tilde) en defaultsPt.a.ts: un
  // sitio con las dos secciones lo muestra con el mismo apellido.
  'Carlos Rodriguez': 'Carlos Oliveira',
  'Con mas de 15 anos de experiencia en la industria automotriz, Carlos lidera nuestro equipo con vision y dedicacion.':
    'Com mais de 15 anos de experiência no setor automotivo, Carlos lidera nossa equipe com visão e dedicação.',
  'Maria Lopez': 'Maria Lopes',
  'Asesor de Ventas': 'Consultor de Vendas',
  'Especialista en atencion al cliente, Maria te ayudara a encontrar el vehiculo perfecto para tus necesidades.':
    'Especialista em atendimento ao cliente, Maria vai ajudar você a encontrar o veículo perfeito para as suas necessidades.',
  'Jorge Martinez': 'Jorge Martins',
  'Servicio Tecnico': 'Serviço Técnico',
  'Tecnico certificado con amplia experiencia en mantenimiento y reparacion de vehiculos de todas las marcas.':
    'Técnico certificado com ampla experiência em manutenção e reparo de veículos de todas as marcas.',
  'Más de 15 años de experiencia en el sector automotriz.': 'Mais de 15 anos de experiência no setor automotivo.',
  'Asesora de Ventas': 'Consultora de Vendas',
  'Especialista en encontrar el vehículo perfecto para cada cliente.': 'Especialista em encontrar o veículo perfeito para cada cliente.',
  'Servicio Técnico': 'Serviço Técnico',
  'Técnico certificado con amplio conocimiento en mecánica automotriz.': 'Técnico certificado com amplo conhecimento em mecânica automotiva.',

  // ── videos/ ────────────────────────────────────────────────────────────────
  'Título del Video': 'Título do Vídeo',
  'Un subtítulo descriptivo para tu video.': 'Um subtítulo descritivo para o seu vídeo.',
  'Título del Video Impactante': 'Título do Vídeo Impactante',
  'Atrae a tus visitantes con contenido visual atractivo.': 'Atraia seus visitantes com conteúdo visual atraente.',

  // ── componentSettings.ts: bloques sueltos, buscadores y portadas ──────────
  'Primer punto de la lista': 'Primeiro item da lista',
  'Segundo punto de la lista': 'Segundo item da lista',
  'Tercer punto de la lista': 'Terceiro item da lista',
  'Bienvenido a': 'Bem-vindo a',
  'Encuentra tu próximo vehículo con nuestra búsqueda inteligente': 'Encontre o seu próximo veículo com a nossa busca inteligente',
  'Click aquí': 'Clique aqui',
  'Tu próximo auto está en': 'Seu próximo carro está em',
  'Nuevo campo': 'Novo campo',
  'Nuevo valor': 'Novo valor',
  'Descripción del valor.': 'Descrição do valor.',

  // ── Toolbox y userComponents: props de fábrica de los bloques sueltos. Se
  //    guardan apenas el nodo nace (localizarArbolNuevo) ───────────────────
  'Nuevo texto': 'Novo texto',
  'Nuevo título': 'Novo título',
  'Título de la tarjeta': 'Título do card',
  'Una descripción breve de lo que ofrece esta tarjeta.': 'Uma breve descrição do que este card oferece.',
  'Título de sección': 'Título da seção',
  'Edit me': 'Edite este texto',
  'Un título que acompaña la imagen': 'Um título que acompanha a imagem',
  'Contá acá lo que quieras destacar. Este bloque combina una imagen con texto y un botón opcional.':
    'Conte aqui o que você quiser destacar. Este bloco combina uma imagem com texto e um botão opcional.',
  'Un beneficio destacado': 'Um benefício em destaque',
  'Explicá en una línea por qué le conviene al cliente.': 'Explique em uma linha por que vale a pena para o cliente.',

  // ── testimonials/: quién dejó cada testimonio de ejemplo ──────────────────
  'Comprador de Toyota Corolla': 'Comprou um Toyota Corolla',
  'Compradora de Honda CR-V': 'Comprou um Honda CR-V',
  'Comprador de Nissan Sentra': 'Comprou um Nissan Sentra',

  // ── utils/clientDefaults.ts: nombre de respaldo dentro de 'Bienvenido a X' ─
  'Nuestra Automotora': 'Nossa Concessionária',
};
